import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	upgrade: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	upgrade: {
		defaultMessage: 'Upgrade',
		id: 'jira-edition-awareness-for-standard-to-premium.standard-to-premium-pub-touchpoint.menu.upgrade',
		description: 'Title for persisted upgrade button menu section',
	},
});
export default messages;
